"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FontColor = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(FontColor, _React$PureComponent);

  function FontColor() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      color: null,
      bgColor: null,
      status: 0
    });

    _defineProperty(_assertThisInitialized(_this), "getUi", function () {
      var _ref = _this.props.ui || {},
          _ref$fontColor = _ref.fontColor,
          fontColor = _ref$fontColor === void 0 ? "51,51,51" : _ref$fontColor,
          _ref$fontAvtiveColor = _ref.fontAvtiveColor,
          fontAvtiveColor = _ref$fontAvtiveColor === void 0 ? "250,100,0" : _ref$fontAvtiveColor,
          _ref$bgColor = _ref.bgColor,
          bgColor = _ref$bgColor === void 0 ? "242, 242, 242" : _ref$bgColor,
          _ref$btnActiveColor = _ref.btnActiveColor,
          btnActiveColor = _ref$btnActiveColor === void 0 ? "239,239,239" : _ref$btnActiveColor,
          _ref$panelBgColor = _ref.panelBgColor,
          panelBgColor = _ref$panelBgColor === void 0 ? "255,255,255" : _ref$panelBgColor;

      return {
        fontColor: fontColor,
        fontAvtiveColor: fontAvtiveColor,
        bgColor: bgColor,
        btnActiveColor: btnActiveColor,
        panelBgColor: panelBgColor
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      var _this$getUi = _this.getUi(),
          fontColor = _this$getUi.fontColor,
          bgColor = _this$getUi.bgColor;

      var disableBgColor = _this.props.disableBgColor;
      var state = {
        color: "rgba(" + fontColor + ")",
        bgColor: null,
        status: 0
      };

      if (!disableBgColor) {
        state.bgColor = "rgba(" + bgColor + ")";
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      if (document.body.clientWidth < 1024) return null;
      var _this$props = _this.props,
          disableHover = _this$props.disableHover,
          disableBgHover = _this$props.disableBgHover,
          disableColorHover = _this$props.disableColorHover;
      if (disableHover) return;

      var _this$getUi2 = _this.getUi(),
          fontAvtiveColor = _this$getUi2.fontAvtiveColor,
          btnActiveColor = _this$getUi2.btnActiveColor;

      var state = {
        status: 1
      };

      if (!disableColorHover) {
        state.color = "rgba(" + fontAvtiveColor + ")";
      }

      if (!disableBgHover) {
        state.bgColor = "rgba(" + btnActiveColor + ")";
      }

      _this.setState(state);
    });

    return _this;
  }

  var _proto = FontColor.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.handleMouseOut();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.ui !== prevProps.ui) {
      var status = this.state.status;

      if (status === 0) {
        this.handleMouseOut();
      } else {
        this.handleMouseOver();
      }
    }
  };

  _proto.render = function render() {
    var _style;

    var _this$state = this.state,
        color = _this$state.color,
        bgColor = _this$state.bgColor,
        status = _this$state.status;
    var _this$props2 = this.props,
        _this$props2$styleKey = _this$props2.styleKey,
        styleKey = _this$props2$styleKey === void 0 ? "color" : _this$props2$styleKey,
        ui = _this$props2.ui;
    var style = (_style = {}, _style[styleKey] = color, _style.backgroundColor = bgColor, _style);
    return _react["default"].cloneElement(this.props.children, {
      style: _extends({}, style),
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut,
      ui: ui,
      isHover: status === 1
    });
  };

  return FontColor;
}(_react["default"].PureComponent);

var _default = FontColor;
exports["default"] = _default;
module.exports = exports.default;